import React, { FunctionComponent } from 'react';
import { Grid, SpacingName } from '@doveit/bricks';
import AgentCard from '../agent-card/AgentCard';
import { Agent } from '../../../domain/graphcms';

export interface AgentListProps {
  agents: Agent[],
}

const AgentList: FunctionComponent<AgentListProps> = ({
  agents,
}) => (
  <Grid gutter={SpacingName.SMALLER}>
    {agents.map((agent) => (
      <Grid.Unit
        size={{ MD: 1 / 2, LG: 1 / 3 }}
        key={agent.id}
      >
        <AgentCard agent={agent} />
      </Grid.Unit>
    ))}
  </Grid>
);

export default AgentList;
